import { createSlice } from '@reduxjs/toolkit';

import { handleRemoveMedicationFromInquiryDraft } from '@store/features/inquiryDraft/removeMedicationFromInquiryDraft/actions';
import eventBus, { EventType } from '@utils/eventBus';

import { IRemoveMedicationFromInquiryDraftState } from './slice.interface';

const initialState: IRemoveMedicationFromInquiryDraftState = {
  isLoading: false,
};

export const removeMedicationFromInquiryDraftSlice = createSlice({
  name: 'remove-medication-from-inquiry-draft',
  initialState,
  reducers: {
    removeDeleteMedicationFromInquiryDraft: state => {
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleRemoveMedicationFromInquiryDraft.pending,
        (state: IRemoveMedicationFromInquiryDraftState) => {
          state.isLoading = true;
        },
      )
      .addCase(
        handleRemoveMedicationFromInquiryDraft.rejected,
        (state: IRemoveMedicationFromInquiryDraftState) => {
          state.isLoading = false;
        },
      )
      .addCase(
        handleRemoveMedicationFromInquiryDraft.fulfilled,
        (state: IRemoveMedicationFromInquiryDraftState) => {
          state.isLoading = false;
          eventBus.emit(EventType.REMOVE_MEDICATION_FROM_INQUIRY_DRAFT_SUCCESS);
        },
      );
  },
});

export const { removeDeleteMedicationFromInquiryDraft } =
  removeMedicationFromInquiryDraftSlice.actions;

export default removeMedicationFromInquiryDraftSlice.reducer;
